/**
 * Google Maps API Configuration Constants
 * 
 * These constants ensure consistency across all components using Google Maps
 * and prevent performance warnings from array recreation on re-renders.
 */

// Standard libraries used across all Google Maps components
// Keep this as a constant to prevent recreation on each render
export const GOOGLE_MAPS_LIBRARIES: ('geometry' | 'places')[] = ['geometry', 'places'] as const

// Google Maps API key (from environment variable)
export const getGoogleMapsApiKey = (): string => {
  return import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ''
}
